import { isLive } from 'lib/helpers/environmentsHelper';
export const logForDev = (...args: any[]) => {
  const isDev = !isLive();

  if (isDev && console) console.log(...args); // eslint-disable-line no-console
};
